var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingBrand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.875V11C0.5 11.3978 0.658035 11.7794 0.93934 12.0607C1.22064 12.342 1.60218 12.5 2 12.5H9.125C9.56821 12.5 10.0071 12.4127 10.4166 12.2431C10.826 12.0735 11.1981 11.8249 11.5115 11.5115C11.8249 11.1981 12.0735 10.826 12.2431 10.4166C12.4127 10.0071 12.5 9.56821 12.5 9.125V3.875C12.5 3.43179 12.4127 2.99292 12.2431 2.58344C12.0735 2.17397 11.8249 1.80191 11.5115 1.48851C11.1981 1.17512 10.826 0.926516 10.4166 0.756907C10.0071 0.587297 9.56821 0.5 9.125 0.5H3.875C2.97989 0.5 2.12145 0.855579 1.48851 1.48851C0.855579 2.12145 0.5 2.97989 0.5 3.875Z",
    stroke: "#003B95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5H3.125C3.52282 3.5 3.90436 3.65804 4.18566 3.93934C4.46696 4.22064 4.625 4.60218 4.625 5C4.625 5.39782 4.46696 5.77936 4.18566 6.06066C3.90436 6.34196 3.52282 6.5 3.125 6.5H0.5V1.25C0.5 1.05109 0.579018 0.860322 0.71967 0.71967C0.860322 0.579018 1.05109 0.5 1.25 0.5H2.375C2.77282 0.5 3.15436 0.658036 3.43566 0.93934C3.71696 1.22064 3.875 1.60218 3.875 2C3.875 2.39782 3.71696 2.77936 3.43566 3.06066C3.15436 3.34196 2.77282 3.5 2.375 3.5H1.25M6.5 6.5H6.5075",
    stroke: "#003B95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingBrand);
export default __webpack_public_path__ + "static/media/booking-brand.96c040243ed5fd4602f920a6446d758c.svg";
export { ForwardRef as ReactComponent };